import { LinearProgress, Typography } from '@mui/material'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import { useFlag } from '@unleash/proxy-client-react'
import formatBytes from '../../../../../utils/formatBytes'

interface Props {
  userProfile: any // Replace 'any' with the actual type of userProfile
}

export default function UtilizationMenu({ userProfile }: Props) {
  const useDummyFileSizeValues = useFlag('useDummyFileSizeValues')
  const totalUsedSpace = userProfile?.counters?.totalSize || 0
  const maxSpace = userProfile?.plan?.storage_limit ?? 0
  const maxSpaceText = maxSpace >= 0 ? formatBytes(maxSpace) : 'Unlimited'
  const formatBytesText = formatBytes(totalUsedSpace)
  const spaceUtilization = (totalUsedSpace / maxSpace) * 100

  if (maxSpace === 0) {
    return null
  }

  // Hide storage utilization UI when feature toggle is enabled
  if (useDummyFileSizeValues) {
    return null
  }

  return (
    <List sx={{ padding: 0 }}>
      <ListItem sx={{ padding: 0, display: 'block' }}>
        {maxSpace >= 0 && (
          <LinearProgress
            aria-label={`Storage: ${formatBytesText} of ${maxSpaceText}`}
            variant="determinate"
            value={totalUsedSpace > 0 ? Math.max(1, Math.min(spaceUtilization, 100)) : 0}
            color="primary"
            sx={{ height: '12px', borderRadius: '8px', opacity: 1 }}
          />
        )}
        <Typography sx={{ mt: '8px', fontWeight: 600 }}>
          Storage: {formatBytesText} of {maxSpaceText}
        </Typography>
      </ListItem>
    </List>
  )
}
